(function($){

    var $controller  = {

        selector: '[data-maxlength]',

        init: function() {
            this.listen();
        },
        
        listen: function() {

            setTimeout(function() {

                $($controller.selector).each(function() {
                    var $this = $(this);
                    var $max = parseInt($this.attr('data-maxlength'));
                    if($max > 0 && $this.text().length > $max) {
                        // traverse
                        if($('p', $this).length) {
                            $('p', $this).each(function() {
                                var $p = $(this);
                                $p.html($p.html().substr(0, $max)).addClass('ellipsis');
                            });
                        } else {
                            $this.html($this.html().substr(0, $max)).addClass('ellipsis');
                        }
                    }
                    $this.removeAttr('data-maxlength');
                });

            }, 100);

        }

    };

    $controller.init();

})(jQuery);


// WEBPACK FOOTER //
// ./tbo/js/util/character-limit.js